"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupedPersonasToCSV = exports.groupedPersona = void 0;

var actions = _interopRequireWildcard(require("../actions"));

var _reselect = require("reselect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  isFetching: false,
  records: {}
}; // $FlowFixMe

var groupedPersona = function groupedPersona(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.READ_GROUPED_PERSONA_REQUEST:
      return _extends({}, state, {
        isFetching: true
      });

    case actions.READ_GROUPED_PERSONA_SUCCESS:
      return {
        records: _extends({}, action.payload),
        isFetching: false
      };

    case actions.READ_GROUPED_PERSONA_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        records: {}
      });

    case actions.READ_GROUPED_PERSONA_EMPTY:
    case actions.SET_AUDIENCE_VIEW:
    case actions.RESET_PAGE_DATA:
      return _extends({}, state, {
        isFetching: false,
        records: {}
      });

    default:
      return state;
  }
};

exports.groupedPersona = groupedPersona;
var groupedPersonasToCSV = (0, _reselect.createSelector)(function (state) {
  return state.groupedPersona.records;
}, function (personaRecords) {
  return {
    data: Object.values(personaRecords).map(function (record) {
      return {
        Category: record.questionLabel,
        Attribute: record.answerLabel,
        Index: record.index,
        'Share of Audience': record.shareOfAudience,
        'Share of Attribute': record.shareOfProperty,
        Population: record.population
      };
    })
  };
});
exports.groupedPersonasToCSV = groupedPersonasToCSV;